(function () {
    'use strict';

    angular.module("imApp").factory("subOperationsService", ['$ihttp', function ($ihttp) {
        let service = {
            getSubOperations: function (parms) {
                return $ihttp.post({
                    method: 2462,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
